var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPokerFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 22.3332C11.4122 22.3332 10.666 23.0794 10.666 23.9998C10.666 24.9203 11.4122 25.6665 12.3327 25.6665H25.666C26.5865 25.6665 27.3327 24.9203 27.3327 23.9998C27.3327 23.0794 26.5865 22.3332 25.666 22.3332H12.3327Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 13.9998C12.3327 13.0794 13.0789 12.3332 13.9993 12.3332H14.016C14.9365 12.3332 15.6827 13.0794 15.6827 13.9998C15.6827 14.9203 14.9365 15.6665 14.016 15.6665H13.9993C13.0789 15.6665 12.3327 14.9203 12.3327 13.9998Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9993 12.3332C23.0789 12.3332 22.3327 13.0794 22.3327 13.9998C22.3327 14.9203 23.0789 15.6665 23.9993 15.6665H24.016C24.9365 15.6665 25.6827 14.9203 25.6827 13.9998C25.6827 13.0794 24.9365 12.3332 24.016 12.3332H23.9993Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9993 0.666504C8.87413 0.666504 0.666016 8.87462 0.666016 18.9998C0.666016 29.1251 8.87413 37.3332 18.9993 37.3332C29.1246 37.3332 37.3327 29.1251 37.3327 18.9998C37.3327 8.87462 29.1246 0.666504 18.9993 0.666504ZM3.99935 18.9998C3.99935 10.7156 10.7151 3.99984 18.9993 3.99984C27.2836 3.99984 33.9993 10.7156 33.9993 18.9998C33.9993 27.2841 27.2836 33.9998 18.9993 33.9998C10.7151 33.9998 3.99935 27.2841 3.99935 18.9998Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.2904,
    y1: -12.7197,
    x2: 18.9993,
    y2: 37.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 19.2904,
    y1: -12.7197,
    x2: 18.9993,
    y2: 37.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 19.2904,
    y1: -12.7197,
    x2: 18.9993,
    y2: 37.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 19.2904,
    y1: -12.7197,
    x2: 18.9993,
    y2: 37.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokerFace);
export default __webpack_public_path__ + "static/media/poker-face.8024e570.svg";
export { ForwardRef as ReactComponent };